
import { Component, Prop, Vue } from 'vue-property-decorator';
import WebsiteRepositoryInterface, { Website } from '../../services/Website/interfaces';

@Component({
  inject: ['websiteRepository'],
})
export default class WebsitePicker extends Vue {
  private websiteRepository!: WebsiteRepositoryInterface;

  public websiteSearchLoading = false;

  public websites: Website[] = [];

  @Prop({ default: 0, required: true, type: Number }) public value!: number;

  private _websiteSearch = '';

  public get websiteSearch(): string {
    return this._websiteSearch;
  }

  public set websiteSearch(val: string) {
    if (!val) {
      return;
    }

    this._websiteSearch = val;

    this.websiteSearchLoading = true;
    this.websiteRepository.searchWebsites(0, val).then((websitesResponse) => {
      this.websites = websitesResponse.Websites;
      this.websiteSearchLoading = false;
    });
  }

  get websiteId(): number {
    return this.value;
  }

  set websiteId(value: number) {
    this.$emit('input', value);
  }
}
